import React, { createContext, useState, useEffect, useContext } from 'react';
import API_ENDPOINTS from '../config/apiConfig';

export const BranchContext = createContext();

export function BranchProvider({ children }) {
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState('');
  const [loadingBranches, setLoadingBranches] = useState(true);

  useEffect(() => {
    let mounted = true;
    async function fetchBranches() {
      try {
        const res = await fetch(API_ENDPOINTS.BRANCHES, { credentials: 'include' });
        if (res.ok) {
          const data = await res.json();
          if (mounted) setBranches(data || []);
        } else {
          if (mounted) setBranches([]);
        }
      } catch (e) {
        if (mounted) setBranches([]);
      } finally {
        if (mounted) setLoadingBranches(false);
      }
    }
    fetchBranches();
    return () => { mounted = false; };
  }, []);

  return (
    <BranchContext.Provider value={{ branches, selectedBranch, setSelectedBranch, loadingBranches }}>
      {children}
    </BranchContext.Provider>
  );
}

export function useBranch() {
  return useContext(BranchContext);
}

export default BranchContext;
